<div class="form-parent">
  <kgrid [apiName]="apiName"
  [noAutoFitColumns]="true" 
  [areaName]="areaName"
  [label]="label"
  [columns]="columns"
  [name]="apiName"
  [isMulti]="false"
  [isEdit]="false"
  [isDelete]="false"
  defaultSortKey="ShamsiStartDate"
  defaultSortKeyKind='asc'
  [actions]="actions"
  [filters]="onFilter"
  [actionTregger]="onActionClick.bind(this)"
  [inputEditorform]="inputEditorform">
</kgrid>
</div>

